module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-chunk-bottom-01.2@2x.a01ab07f.jpg";